import {
  authTitle,
  authSmallText,
  button,
  buttonBlock,
  buttonPrimary,
  colors,
  fonts,
} from '../../theme';
import authModalStyles from './style';

const styles = {
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 1.5,
  },
  // Brand font, as the invite of the app.
  header: {
    textAlign: 'center',
    fontFamily: fonts.display,
    fontSize: 21,
    fontWeight: 700,
    lineHeight: 1,
    letterSpacing: '0.6px',
    textTransform: 'uppercase',
    color: colors.text,
  },
  fan: {
    position: 'relative',
    height: 196,
  },
  glow: {
    position: 'absolute',
    top: 40,
    left: '50%',
    width: 260,
    height: 150,
    ml: '-130px',
    borderRadius: '50%',
    background: 'radial-gradient(closest-side, rgba(255,215,0,0.28), rgba(255,215,0,0))',
  },
  clip: {
    position: 'absolute',
    top: 28,
    left: '50%',
    width: 98,
    height: 131,
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid #2a3542',
    backgroundColor: colors.surfaceRaised,
    boxShadow: '0 10px 24px rgba(0, 0, 0, 0.6)',
  },
  clipLeft: {
    ml: '-150px',
    transform: 'rotate(-8deg)',
  },
  clipRight: {
    ml: '52px',
    transform: 'rotate(8deg)',
  },
  clipCenter: {
    top: 6,
    width: 124,
    height: 166,
    ml: '-62px',
    zIndex: 2,
    border: '1.5px solid #FFD700',
    boxShadow: '0 0 0 4px rgba(255,215,0,0.12), 0 14px 30px rgba(0, 0, 0, 0.7)',
  },
  clipImage: {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  // Top 1/2/3 as in the weekly ranking.
  pill: {
    position: 'absolute',
    top: 5,
    height: 17,
    px: '7px',
    borderRadius: '8.5px',
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
    display: 'flex',
    alignItems: 'center',
    fontFamily: fonts.text,
    fontSize: 8.9,
    fontWeight: 800,
    whiteSpace: 'nowrap',
  },
  pillLeft: {
    left: 5,
  },
  pillRight: {
    right: 5,
  },
  pillCenter: {
    top: 6,
    left: '50%',
    transform: 'translateX(-50%)',
    height: 18.7,
    px: '7.7px',
    borderRadius: '9.4px',
    fontSize: 9.8,
  },
  play: {
    position: 'absolute',
    left: 7,
    bottom: 7,
    width: 22,
    height: 22,
    borderRadius: '50%',
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  playIcon: {
    fontSize: 14,
    color: colors.text,
  },
  ring: {
    alignSelf: 'center',
    width: 78,
    height: 78,
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #FFD700, #ff8a3d, #F44336)',
    boxShadow: '0 0 28px rgba(255, 180, 0, 0.25)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  ringInner: {
    width: 70,
    height: 70,
    borderRadius: '50%',
    backgroundColor: colors.surface,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  ringCount: {
    fontFamily: fonts.text,
    fontSize: 26,
    fontWeight: 700,
    lineHeight: 1,
    color: colors.text,
  },
  ringLabel: {
    mt: '3px',
    fontFamily: fonts.text,
    fontSize: 9.5,
    fontWeight: 500,
    color: colors.textSecondary,
  },
  title: authTitle,
  // Clips: the title sits closer to its text, the block a bit higher.
  titleClips: {
    mt: '-8px',
  },
  textClips: {
    mt: '-7.4px',
    mb: '8px',
  },
  text: {
    ...authSmallText,
    mt: -0.5,
    fontSize: 14,
    textAlign: 'center',
    textWrap: 'balance',
  },
  reasons: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    my: 0.5,
  },
  reason: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    fontFamily: fonts.text,
    fontSize: 13.5,
    fontWeight: 500,
    color: colors.textLight,
  },
  reasonIcon: {
    width: 32,
    height: 32,
    flexShrink: 0,
    boxSizing: 'border-box',
    borderRadius: '9px',
    border: `1px solid ${colors.border}`,
    backgroundColor: colors.surfaceRaised,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  primary: {
    ...buttonPrimary,
    ...buttonBlock,
  },
  secondary: {
    ...button,
    ...buttonBlock,
  },
  later: authModalStyles.later,
};

export default styles;
